<template>
  <div>
    <b-row class="justify-content-between align-items-end">
      <b-col
        :style="xxx"
        cols="12"
        :md="huayData.type === 1?'7':'12'"
      >
        <b-card
          :class="huayData.type === 1?'mb-2 mb-md-0':'mb-2'"
          border-variant="lightGrey"
        >
          <validation-observer
            v-if="huayData.type === 1"
            ref="simpleRules"
          >
            <b-form @submit.prevent>
              <b-form-group
                :label="$t('รางวัลที่ 1')"
                label-for="รางวัลที่ 1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThree"
                  rules="required|digits:6"
                >
                  <b-form-input
                    v-model="huayData.topThree"
                    :placeholder="$t('รางวัลที่ 1')"
                    minlength="6"
                    maxlength="6"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สามตัวหน้าลำดับที่ 1')"
                label-for="สามตัวหน้าลำดับที่ 1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThreeFront1"
                  rules="required|digits:3"
                >
                  <b-form-input
                    v-model="huayData.topThreeFront1"
                    :placeholder="$t('สามตัวหน้าลำดับที่ 1')"
                    minlength="3"
                    maxlength="3"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สามตัวหน้าลำดับที่ 2')"
                label-for="สามตัวหน้าลำดับที่ 2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThreeFront2"
                  rules="required|digits:3"
                >
                  <b-form-input
                    v-model="huayData.topThreeFront2"
                    :placeholder="$t('สามตัวหน้าลำดับที่ 2')"
                    minlength="3"
                    maxlength="3"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สามตัวหลังลำดับที่ 1')"
                label-for="สามตัวหลังลำดับที่ 1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThreeBack1"
                  rules="required|digits:3"
                >
                  <b-form-input
                    v-model="huayData.topThreeBack1"
                    :placeholder="$t('สามตัวหลังลำดับที่ 1')"
                    minlength="3"
                    maxlength="3"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สามตัวหลังลำดับที่ 2')"
                label-for="สามตัวหลังลำดับที่ 2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThreeBack2"
                  rules="required|digits:3"
                >
                  <b-form-input
                    v-model="huayData.topThreeBack2"
                    :placeholder="$t('สามตัวหลังลำดับที่ 2')"
                    minlength="3"
                    maxlength="3"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สองตัว')"
                label-for="สองตัว"
              >
                <validation-provider
                  #default="{ errors }"
                  name="bottomTwo"
                  rules="required|digits:2"
                >
                  <b-form-input
                    v-model="huayData.bottomTwo"
                    :placeholder="$t('สองตัว')"
                    minlength="2"
                    maxlength="2"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </validation-observer>
          <validation-observer
            v-else-if="huayData.type === 2 || huayData.type === 3 || huayData.type === 4 || huayData.type === 6"
            ref="simpleRules"
          >
            <b-form

              @submit.prevent
            >
              <!-- 4/5 ตัว: ผลหลักเต็มหลัก (FOUR_FIVE_DIGIT_BETS ข้อ 6) · กรอกแล้วเติม 3 ตัวบนให้อัตโนมัติ -->
              <b-form-group
                v-if="fullNumberLength"
                :label="fullNumberLabel"
                label-for="fullNumber"
              >
                <validation-provider
                  #default="{ errors }"
                  name="fullNumber"
                  :rules="`${fourFiveDigit.required ? 'required|' : ''}digits:${fullNumberLength}`"
                >
                  <b-form-input
                    id="fullNumber"
                    :value="huayData.fullNumber"
                    :placeholder="fullNumberLabel"
                    :minlength="fullNumberLength"
                    :maxlength="fullNumberLength"
                    :disabled="isDisbleResultForm"
                    @input="onFullNumberInput"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สามตัวบน')"
                label-for="สามตัวบน"
              >
                <validation-provider
                  #default="{ errors }"
                  name="topThree"
                  rules="required|digits:3"
                >
                  <b-form-input
                    v-model="huayData.topThree"
                    :placeholder="$t('สามตัวบน')"
                    minlength="3"
                    maxlength="3"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :label="$t('สองตัวล่าง')"
                label-for="สองตัวล่าง"
              >
                <validation-provider
                  #default="{ errors }"
                  name="bottomTwo"
                  rules="required|digits:2"
                >
                  <b-form-input
                    v-model="huayData.bottomTwo"
                    :placeholder="$t('สองตัวล่าง')"
                    minlength="2"
                    maxlength="2"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </validation-observer>
          <validation-observer
            v-else-if="huayData.type === 5"
            ref="simpleRules"
          >
            <b-form

              @submit.prevent
            >
              <b-form-group
                :label="$t('เลขชุด 4 ตัว')"
                label-for="เลขชุด 4 ตัว"
              >
                <validation-provider
                  #default="{ errors }"
                  name="fourNumber"
                  rules="required|digits:4"
                >
                  <b-form-input
                    v-model="huayData.fourNumber"
                    :placeholder="$t('เลขชุด 4 ตัว')"
                    minlength="4"
                    maxlength="4"
                    :disabled="isDisbleResultForm"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </validation-observer>
          <ResultReferencePanel
            ref="resultReferences"
            :huay-id="String($route.query.id || '')"
            :round-id="String(huayData.roundId || '')"
            :huay-data="huayData"
            :full-number-length="fullNumberLength || 0"
            :can-fill="!isDisbleResultForm && !actionPending && $can('update', 'lotto.round')"
            @enabled="referenceEnabled = $event"
            @pulling="referencePulling = $event"
            @fill="applyReference"
          />
        </b-card>
      </b-col>
      <b-col
        cols="12"
        :md="huayData.type === 1?'5':'12'"
        :class="huayData.type === 1?'mt-0':''"
      >
        <div v-if="huayData.status >= 5 && huayData.status <= 6">
          <b-list-group v-if="huayData.type !== 5">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('3 ตัวบน') }}</span>
              {{ toNumber(calculatedResult.topThree.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('3 ตัวโต้ด') }}</span>
              {{ toNumber(calculatedResult.topThreeJump.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              v-if="huayData.type === 1"
              class="d-flex justify-content-between align-items-center"
            >
              <span>{{ $t('3 ตัวหน้า') }}</span>
              {{ toNumber(calculatedResult.topThreeFront.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              v-if="huayData.type === 1"
              class="d-flex justify-content-between align-items-center"
            >
              <span>{{ $t('3 ตัวท้าย') }}</span>
              {{ toNumber(calculatedResult.topThreeBack.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('2 ตัวบน') }}</span>
              {{ toNumber(calculatedResult.topTwo.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('2 ตัวล่าง') }}</span>
              {{ toNumber(calculatedResult.bottomTwo.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('วิ่งบน') }}</span>
              {{ toNumber(calculatedResult.topRun.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('วิ่งล่าง') }}</span>
              {{ toNumber(calculatedResult.bottomRun.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              v-for="row in fourFiveDigitSummaryRows"
              :key="row.key"
              class="d-flex justify-content-between align-items-center"
            >
              <span>{{ $t(row.label) }}</span>
              {{ toNumber(Number(calculatedResult[row.key] || 0).toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              variant="success"
            >
              <span>{{ $t('ยอดเดิมพันเครดิตทั้งหมด') }}</span>
              {{ toNumber(calculatedResult.sumRollingAmount.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              variant="danger"
            >
              <span>{{ $t('ยอดจ่ายเครดิตทั้งหมด') }}</span>
              {{ toNumber(calculatedResult.sumWinAmount.toFixed(2)) }}
            </b-list-group-item>
          </b-list-group>
          <b-list-group v-if="huayData.type === 5">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('4 ตัวตรง') }}</span>
              {{ toNumber(calculatedResult.fourNumber.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('4 ตัวโต๊ด') }}</span>
              {{ toNumber(calculatedResult.fourNumberJump.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('3 ตัวตรง') }}</span>
              {{ toNumber(calculatedResult.topThree.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('3 ตัวโต๊ด') }}</span>
              {{ toNumber(calculatedResult.topThreeJump.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('2 ตัวหน้า') }}</span>
              {{ toNumber(calculatedResult.topTwo.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>{{ $t('2 ตัวหลัง') }}</span>
              {{ toNumber(calculatedResult.bottomTwo.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              variant="success"
            >
              <span>{{ $t('ยอดเดิมพันเครดิตทั้งหมด') }}</span>
              {{ toNumber(calculatedResult.sumRollingAmount.toFixed(2)) }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              variant="danger"
            >
              <span>{{ $t('ยอดจ่ายเครดิตทั้งหมด') }}</span>
              {{ toNumber(calculatedResult.sumWinAmount.toFixed(2)) }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
    <div class="text-right">
      <template v-if="huayData.status === 1">
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="dark"
          size="13px"
          style="margin-right:5px"
          class="mt-2"
          @click="refund"
        >{{ $t('คืนโพย') }}
        </b-button>
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="danger"
          size="13px"
          class="mt-2"
          @click="pause"
        >{{ $t('หยุดพักชั่วคราว') }}
        </b-button>
      </template>
      <template v-else-if="huayData.status === 2">
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="dark"
          size="13px"
          style="margin-right:5px"
          class="mt-2"
          @click="refund"
        >{{ $t('คืนโพย') }}
        </b-button>
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="primary"
          size="13px"
          class="mt-2"
          @click="resume"
        >{{ $t('เปิดเเทงต่อ') }}
        </b-button>
      </template>
      <template v-else-if="huayData.status === 3">
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="dark"
          size="13px"
          style="margin-right:5px"
          class="mt-2"
          @click="refund"
        >{{ $t('คืนโพย') }}
        </b-button>
        <b-button
          variant="secondary"
          size="13px"
          style="margin-right:5px"
          class="mt-2"
          :disabled="actionPending || !referenceEnabled || referencePulling"
          :aria-busy="referencePulling"
          @click="$refs.resultReferences.fillBest()"
        >
          <b-spinner
            v-if="referencePulling"
            small
            class="mr-25"
            aria-hidden="true"
          />
          {{ $t('ดึงผล') }}
        </b-button>
        <b-button
          v-if="$can('update', 'lotto.round')"
          variant="primary"
          size="13px"
          class="mt-2"
          :disabled="actionPending"
          @click="calculateCredit"
        >{{ $t('คำนวนราคา') }}
        </b-button>
      </template>
      <template v-else-if="huayData.status === 5">
        <div>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="primary"
            size="13px"
            style="margin-right:5px"
            class="mt-2"
            :disabled="actionPending"
            @click="calculateCredit"
          >{{ $t('คำนวนอีกครั้ง') }}
          </b-button>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="cyan-7"
            size="13px"
            class="mt-2"
            @click="showAnnounce"
          >{{ $t('ประกาศรางวัล') }}
          </b-button>
        </div>
        <div>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="dark"
            size="13px"
            style="margin-right:5px"
            class="mt-2"
            @click="refund"
          >{{ $t('คืนโพย') }}
          </b-button>
          <b-button
            variant="secondary"
            size="13px"
            class="mt-2"
            :disabled="actionPending || !referenceEnabled || referencePulling"
            :aria-busy="referencePulling"
            @click="$refs.resultReferences.fillBest()"
          >
            <b-spinner
              v-if="referencePulling"
              small
              class="mr-25"
              aria-hidden="true"
            />
            {{ $t('ดึงผล') }}
          </b-button>
        </div>
      </template>
      <template v-else-if="huayData.status === 6">
        <div>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="dark"
            size="13px"
            style="margin-right:5px"
            class="mt-2"
            @click="refund"
          >{{ $t('คืนโพย') }}
          </b-button>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="danger"
            size="13px"
            style="margin-right:5px"
            class="mt-2"
            @click="cancelAnnounce"
          >{{ $t('ยกเลิกประกาศ') }}
          </b-button>
          <b-button
            v-if="$can('update', 'lotto.round')"
            variant="cyan-7"
            size="13px"
            class="mt-2"
            :disabled="actionPending"
            @click="dispatchCredit"
          >{{ $t('จ่ายเครดิต') }}
          </b-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ResultReferencePanel from '@/views/components/ResultReferencePanel.vue'
import dispatchLottoEvent from '@/service/resultReferenceActions'
import lottoService from '@/service/lottoService'
import fourFiveDigitService from '@/service/fourFiveDigitService'
import { FOUR_FIVE_DIGIT_SHORT_LABELS } from '@/utils/betTypes'
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BListGroup, BListGroupItem, BCard, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {} from '@validations'

export default {
  directives: {
    Ripple,
  },
  components: {
    ResultReferencePanel,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BListGroup,
    BListGroupItem,
  },
  props: {
    huayData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    // 4/5 ตัว: { required, length, usesTopThree } ของรอบนี้ · null = ยังไม่รู้ / หวยนี้ไม่มี 4/5 ตัว
    fourFiveDigit: null,
    // รอบนี้มีเลขเต็มเก็บไว้แล้ว — ช่องยังอยู่แม้ลบค่าออกระหว่างแก้
    fullNumberStored: false,
    referenceEnabled: false,
    referencePulling: false,
    actionPending: false,
    result: {
      huayId: '',
      roundId: '',
      roundDate: '',
      roundStartDate: '',
      roundEndDate: '',
      lastUpdate: '',
      status: '',
      topThree: '',
      topThreeFront1: '',
      topThreeFront2: '',
      topThreeBack1: '',
      topThreeBack2: '',
      topTwo: '',
      bottomTwo: '',
      fourNumber: '',
    },
    calculatedResult: {
      topThree: 0,
      topThreeJump: 0,
      topThreeFront: 0,
      topThreeBack: 0,
      topTwo: 0,
      bottomTwo: 0,
      topRun: 0,
      bottomRun: 0,
      fourNumber: 0,
      fourNumberJump: 0,
      sumRollingAmount: 0,
      sumWinAmount: 0,
    },
  }),
  computed: {
    xxx() {
      return this.huayData.status < 5 || this.huayData.status > 6
        ? 'min-width:100% !important'
        : ''
    },
    isDisbleResultForm() {
      return this.huayData.status !== 3 && this.huayData.status !== 5
    },
    toNumber() {
      return this.$store.state.app.toNumber
    },
    // ช่องเลขเต็มมีเฉพาะหวยที่ไม่ใช่รัฐบาลใน allowlist (รัฐบาลใช้รางวัลที่ 1 เดิม) และรอบนี้ต้องกรอก
    // หรือเคยเก็บไว้แล้ว — ระบบที่ไม่ได้ใช้ฟีเจอร์นี้จึงเห็นฟอร์มออกผลเหมือนเดิม
    fullNumberLength() {
      const requirement = this.fourFiveDigit
      return requirement && !requirement.usesTopThree && (requirement.required || this.fullNumberStored)
        ? requirement.length : null
    },
    fullNumberLabel() {
      return `${this.$t('เลขเต็ม')} (${this.fullNumberLength} ${this.$t('หลัก')})`
    },
    // แถวยอดจ่าย 4/5 ตัว: มียอดจริง หรือรอบนี้ต้องใช้เลขเต็ม (ประเภทที่ผลหลักของหวยตัดสินได้)
    // ระบบที่ไม่ได้ใช้ฟีเจอร์นี้จึงเห็นรายการเหมือนเดิมทุกแถว
    fourFiveDigitSummaryRows() {
      const length = this.fourFiveDigit && this.fourFiveDigit.required ? this.fourFiveDigit.length : 0
      return [[41, 'topFour'], [42, 'topFourJump'], [51, 'topFive'], [52, 'topFiveJump']]
        .filter(([type, key]) => length >= Math.floor(type / 10) || Number(this.calculatedResult[key] || 0) !== 0)
        .map(([type, key]) => ({ key, label: FOUR_FIVE_DIGIT_SHORT_LABELS[type] }))
    },
  },
  watch: {
    'huayData.roundId': 'loadFourFiveDigitRequirement',
    'huayData.fullNumber': {
      handler(value) {
        if (value) this.fullNumberStored = true
      },
      immediate: true,
    },
    huayData: {
      async handler(val) {
        if (val.status === 5 || val.status === 6) {
          const res = await lottoService.getAuthen(`huay/calculate-histrory/${this.huayData.id}`)
          if (res.status === 200) this.calculatedResult = res.data
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.loadFourFiveDigitRequirement()
    if (this.huayData.status === 5 || this.huayData.status === 6) {
      const res = await lottoService.getAuthen(`huay/calculate-histrory/${this.huayData.id}`)
      if (res.status === 200) this.calculatedResult = res.data
    }
  },
  methods: {
    async loadFourFiveDigitRequirement() {
      const { id, roundId } = this.huayData
      this.fullNumberStored = Boolean(this.huayData.fullNumber)
      if (!id) return
      const requirement = await fourFiveDigitService.resultRequirement(id, roundId)
      if (id === this.huayData.id && roundId === this.huayData.roundId) {
        this.fourFiveDigit = requirement && requirement.length ? requirement : null
      }
    },
    onFullNumberInput(value) {
      this.$set(this.huayData, 'fullNumber', value)
      if (/^\d+$/.test(value || '') && value.length === this.fullNumberLength) {
        this.huayData.topThree = value.slice(-3)
      }
    },
    pad2(number) {
      return (number < 10 ? '0' : '') + number
    },
    ToDateString(_d, time) {
      return (
        `${this.pad2(_d.getDate())
        }/${
          this.pad2(_d.getMonth() + 1)
        }/${
          _d.getFullYear()
        } ${
          time}`
      )
    },
    pause() {
      // หยุดพักชั่วคราว
      this.dispatchEvent('pause')
    },
    resume() {
      // เปิดเเทงต่อ
      this.dispatchEvent('resume')
    },
    refund() {
      // คืนเงิน
      this.dispatchEvent('refund')
      // this.dispatchSocketEvent("RefundHuay");
    },
    async calculateCredit() {
      // คำนวนราคา
      const {
        topThree,
        topThreeFront1,
        topThreeFront2,
        topThreeBack1,
        topThreeBack2,
        topTwo,
        bottomTwo,
        fourNumber,
        fullNumber,
      } = this.huayData

      const success = await this.$refs.simpleRules.validate()
      if (!success) {
        this.$swal({
          dark: true,
          title: this.$t('Warning!'),
          text: this.$t('กรุณากรอกรางวัลให้ถูกต้อง'),
          icon: 'warning',
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        return
      }
      if (
        (topThree === '' || topThree == null)
          && (topThreeFront1 === '' || topThreeFront1 == null)
          && (topThreeFront2 === '' || topThreeFront2 == null)
          && (topThreeBack1 === '' || topThreeBack1 == null)
          && (topThreeBack2 === '' || topThreeBack2 == null)
          && (topTwo === '' || topTwo == null)
          && (bottomTwo === '' || bottomTwo == null)
          && (fourNumber === '' || fourNumber == null)
      ) {
        this.$swal({
          dark: true,
          title: this.$t('Warning!'),
          text: this.$t('คุณยังไม่ได้กรอกผลรางวัล'),
          icon: 'warning',
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
        return
      }

      this.dispatchEvent('calculate', '', {
        topThree,
        topThreeFront1,
        topThreeFront2,
        topThreeBack1,
        topThreeBack2,
        topTwo,
        bottomTwo,
        fourNumber,
        fullNumber: this.fullNumberLength ? fullNumber || null : null,
      })

      // this.dispatchSocketEvent("CalculateCredit", {
      //   topThree,
      //   topThreeFront1,
      //   topThreeFront2,
      //   topThreeBack1,
      //   topThreeBack2,
      //   topTwo,
      //   bottomTwo,
      //   fourNumber
      // });
    },
    showAnnounce() {
      this.dispatchEvent('annouce', '?announce=true', {}, e => {
        if (e.status === 200) {
          this.calculatedResult = e.data.summary
        }
      })
    },
    cancelAnnounce() {
      this.dispatchEvent('annouce', '?announce=false', {}, e => {
        if (e.status === 200) {
          this.calculatedResult = e.data.summary
        }
      })
    },
    dispatchCredit() {
      this.dispatchEvent('dispatch')
      // this.dispatchSocketEvent("DispatchHuayReward");
    },
    dispatchEvent(event, param, arg, callback) {
      return dispatchLottoEvent(this, event, param, arg, callback)
    },
    applyReference(numbers) {
      if (this.isDisbleResultForm || this.actionPending) return
      // ช่องเลขเต็มอาจยังไม่มี key ใน huayData จนกว่าจะพิมพ์ครั้งแรก · แผงส่งเลขเต็มมาเฉพาะเมื่อครบทุกหลัก
      Object.keys(numbers).forEach(key => {
        if (key === 'fullNumber' || Object.prototype.hasOwnProperty.call(this.huayData, key)) this.$set(this.huayData, key, numbers[key])
      })
    },
    // dispatchSocketEvent(event, arg) {
    //   const { id } = this.$route.query
    //   if (id) {
    //     this.$q
    //       .dialog({
    //         title: 'Confirm',
    //         message: 'คุณเเน่ใจว่าต้องการดำเนินการใช่หรือไม่',
    //         cancel: true,
    //         dark: this.dark,
    //       })
    //       .onOk(async () => {
    //         if (this.connection) {
    //           // eslint-disable-next-line no-shadow
    //           const { id } = this.$route.query
    //           if (arg) {
    //             this.connection
    //               .invoke(event, id * 1, arg)
    //               .catch(err => console.error(err.toString()))
    //           } else {
    //             this.connection.invoke(event, id * 1)
    //               .catch(err => console.error(err.toString()))
    //           }
    //         }
    //       })
    //   }
    // },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';

.border-lightGrey {
  border: 1px solid rgba(34, 41, 47, 0.125)
}

.dark-layout {
  .border-lightGrey {
    border-color: #3b4253;;
  }
}
</style>
